// CartButton.tsx (дизайн 2 — плавающая)
import React from "react";
import { useSelector } from "react-redux";
import { MdShoppingCart, MdPlaylistAdd } from "react-icons/md";
import { useCartModals } from "../../../../../common/hooks/useCartModals";
import { selectCurrentCluster } from "../../../../../store/slices/currentClusterSlice";
import { RootState } from "../../../../../store/store";
import { CartItem, ComplexOrderItem } from "../../../../types/types";
import styles from "./CartButton.module.scss";

export default function CartButton() {
  const { openCart, openComplexCart } = useCartModals();
  const cluster = useSelector(selectCurrentCluster);
  const { items: regularItems } = useSelector((state: RootState) => state.cart);
  const { items: complexItems } = useSelector(
    (state: RootState) => state.complexOrderCart,
  );

  const hasRegular = cluster?.regularSales !== false;
  const hasComplex = cluster?.complexSales === true;

  const regularTotal = regularItems.reduce(
    (sum: number, item: CartItem) => sum + item.quantity,
    0,
  );
  const complexTotal = complexItems.reduce(
    (sum: number, item: ComplexOrderItem) => sum + item.quantity,
    0,
  );

  if (!hasRegular && !hasComplex) return null;

  return (
    <div className={styles.wrapper}>
      {hasRegular && (
        <button className={styles.cartButton} onClick={openCart}>
          <MdShoppingCart size={28} />
          {regularTotal > 0 && (
            <div className={styles.badge}>
              <span>{regularTotal > 99 ? "99+" : regularTotal}</span>
            </div>
          )}
        </button>
      )}
      {hasComplex && (
        <button className={styles.cartButton} onClick={openComplexCart}>
          <MdPlaylistAdd size={28} />
          {complexTotal > 0 && (
            <div className={styles.badge}>
              <span>{complexTotal > 99 ? "99+" : complexTotal}</span>
            </div>
          )}
        </button>
      )}
    </div>
  );
}
